import "../../modal.scss";
import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import { Datatable } from "../temporadasTable/Datatable";
import { TemporadasState } from "../../../context/temporadas/TemporadasState";

Modal.setAppElement("#root"); // Necesario para accesibilidad

const TemporadasModal = ({ selectID, selectDESC }) => {
  let nochoice = "Buscar Temporada";
  const [searchIdItem, setSearchIdItem] = useState("");
  const [searchDescItem, setSearchDescItem] = useState(nochoice);
  const searchInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (searchIdItem) {
      selectID(searchIdItem);
      selectDESC(searchDescItem);
    }
  }, [searchIdItem, selectID, selectDESC]);

  const handleRowClick = (selectedId, selectedDesc) => {
    setSearchIdItem(selectedId);
    setSearchDescItem(selectedDesc);
    setIsModalOpen(false); // Cierra el modal automáticamente
  };

  const handleClear = () => {
    setSearchIdItem("");
    setSearchDescItem(nochoice);
  };

  return (
    <>
      <div className="inputWrapper">
        <input
          type="text"
          value={searchDescItem}
          readOnly // Hace que el campo no sea editable
          ref={searchInputRef}
        />
        {!searchDescItem || searchDescItem === nochoice ? (
          <button className="SearchButton" onClick={() => setIsModalOpen(true)}>
            🔍
          </button>
        ) : (
          <button className="clearButton" onClick={handleClear}>
            ❌
          </button>
        )}

      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Seleccionar"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="data-grid-container">
          <div className="datatable" style={{ height: '100%', maxHeight: 'calc(80vh - 60px)', overflowY: 'auto' }}>
            <TemporadasState>
              <Datatable
                onSelect={handleRowClick}
                onClose={() => setIsModalOpen(false)}
              />
            </TemporadasState>
          </div>

        </div>
        <button
          className="modalCloseButton"
          onClick={() => setIsModalOpen(false)}
        >
          ❌
        </button>
      </Modal>
    </>
  );
};

export default TemporadasModal;
